import {
  Add,
  ArrowDownward,
  ArrowUpward,
  ChevronRight,
  Delete,
  Edit,
  ExpandMore,
  Folder,
  FolderOpen,
} from "@mui/icons-material"
import { Button, Spinner } from "reactstrap"

export const TreeNode = ({
                           node,
                           level = 0,
                           isFirst = false,
                           isLast = false,
                           onToggle,
                           onEdit,
                           onCreate,
                           onDelete,
                           onMove,
                           loading = false,
                           disabled = false,
                           translation = {},
                         }) => {
  const hasChildren = node.children && node.children.length > 0;
  const paddingLeft = level * 40;

  const handleToggleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (hasChildren && onToggle) {
      onToggle(node.id, node.type);
    }
  };

  const getBackgroundClass = () => {
    if (level === 0) return 'bg-light';
    if (level === 1) return 'bg-light-subtle';
    return 'bg-white';
  };

  const getBorderClass = () => {
    if (level > 0) return 'border-start border-2 border-light';
    return '';
  };

  return (
    <div>
      <div
        className={`d-flex align-items-center p-2 border-bottom ${getBackgroundClass()} ${getBorderClass()}`}
        style={{
          paddingLeft: `${paddingLeft + 16}px`,
          marginLeft: level > 0 ? `${level * 12}px` : '0'
        }}
      >
        <div
          className="me-2"
          data-testid={`toggle-${node.type}-${node.id}`}
          style={{ width: '24px', cursor: hasChildren ? 'pointer' : 'default' }}
          onClick={handleToggleClick}
        >
          {hasChildren ? (
            node.expanded ? <ExpandMore fontSize="small" /> : <ChevronRight fontSize="small" />
          ) : level > 0 ? (
            <div style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ width: '2px', height: '2px', backgroundColor: '#dee2e6', borderRadius: '50%' }} />
            </div>
          ) : null}
        </div>

        <div className="me-2">
          {node.icone ? (
            <img
              src={node.icone}
              alt="ícone"
              style={{ width: '24px', height: '24px' }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'inline';
              }}
            />
          ) : null}
          <div style={{ display: node.icone ? 'none' : 'inline' }}>
            {hasChildren && node.expanded ? <FolderOpen /> : <Folder />}
          </div>
        </div>

        <div className="flex-grow-1">
          <span className={`badge badge-soft-${node.type === 'menu' ? 'primary' : 'info'} me-2`} style={{ fontSize: '0.7rem' }}>
            {node.type === 'menu' ? 'Menu' : 'Grupo'}
          </span>
          <strong style={{ fontSize: level === 0 ? '1rem' : '0.9rem' }}>
            {node.nome}
          </strong>
          {node.type === 'group' && node.grupo && (
            <span className="text-muted ms-2" style={{ fontSize: '0.8rem' }}>
              · {node.grupo.Codigo} - {node.grupo.Descricao}
            </span>
          )}
        </div>

        <div className="d-flex gap-1">
          {loading ? (
            <Spinner color="primary" size="sm" />
          ) : (
            <>
              <Button
                color="secondary"
                size="sm"
                outline
                onClick={(e) => {
                  e.stopPropagation();
                  onMove && onMove(node, 'subir');
                }}
                disabled={disabled || isFirst}
                title={translation.moveUp}
              >
                <ArrowUpward fontSize="small" />
              </Button>

              <Button
                color="secondary"
                size="sm"
                outline
                onClick={(e) => {
                  e.stopPropagation();
                  onMove && onMove(node, 'descer');
                }}
                disabled={disabled || isLast}
                title={translation.moveDown}
              >
                <ArrowDownward fontSize="small" />
              </Button>

              <Button
                color="warning"
                size="sm"
                outline
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit && onEdit(node);
                }}
                disabled={disabled}
                title="Editar"
              >
                <Edit fontSize="small" />
              </Button>

              {node.type === 'menu' && (
                <Button
                  color="success"
                  size="sm"
                  outline
                  onClick={(e) => {
                    e.stopPropagation();
                    onCreate && onCreate(node);
                  }}
                  disabled={disabled}
                  title={translation.groupsAddTitle}
                  className="d-inline-flex align-items-center gap-1 text-nowrap"
                >
                  <Add fontSize="small" />
                  {translation.groupsAddTitle}
                </Button>
              )}

              <Button
                color="danger"
                size="sm"
                outline
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete && onDelete(node);
                }}
                disabled={disabled}
                title="Excluir"
              >
                <Delete fontSize="small" />
              </Button>
            </>
          )}
        </div>
      </div>

      {hasChildren && node.expanded && (
        <div>
          {node.children.map((child, index) => (
            <TreeNode
              key={child.id}
              node={child}
              level={level + 1}
              isFirst={index === 0}
              isLast={index === node.children.length - 1}
              onToggle={onToggle}
              onEdit={onEdit}
              onCreate={onCreate}
              onDelete={onDelete}
              onMove={onMove}
              loading={loading}
              disabled={disabled}
              translation={translation}
            />
          ))}
        </div>
      )}
    </div>
  );
};
